import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, useTemplateRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { showError } from '@services/utils/dialog';
import NcButton from '@nextcloud/vue/components/NcButton';

import Modal from './Modal.vue';

import { useModal } from '@services/modal';
import { t } from '@services/l10n';
import { isAbortError, useAbort } from '@services/utils/abort-vue';
import * as utils from '@services/utils/common';
import * as dav from '@services/dav';
import client from '@services/dav/client';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AlbumDeleteModal',
},
  __name: 'AlbumDeleteModal',
  setup(__props, { expose: __expose }) {



const route = useRoute();
const router = useRouter();
const modal = useTemplateRef('modal');
const { show, close } = useModal(modal);

const user = computed(() => route.params.user?.toString());
const name = computed(() => route.params.name?.toString());
const owned = computed(() => user.value === utils.uid);
const abort = useAbort();

function open() {
  show.value = true;
}

function cleanup() {
  abort.abort();
  show.value = false;
}

async function save() {
  const signal = abort.renew();
  try {
    await client.deleteFile(dav.getAlbumPath(user.value, name.value), { signal });
    signal.throwIfAborted();
    await close();
    await router.push({ name: 'albums-list' });
  } catch (error) {
    if (isAbortError(error)) return;
    console.error(error);
    showError(t('memories', 'Failed to delete {name}.', { name: name.value }));
  }
}

__expose({ open });

return (_ctx: any,_cache: any) => {
  return (_unref(show))
    ? (_openBlock(), _createBlock(Modal, {
        key: 0,
        ref_key: "modal",
        ref: modal,
        onClose: cleanup
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(owned.value ? _unref(t)('memories', 'Remove Album') : _unref(t)('memories', 'Leave Album')), 1)
        ]),
        buttons: _withCtx(() => [
          _createVNode(_unref(NcButton), {
            onClick: save,
            class: "button",
            variant: "error"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('memories', 'Delete')), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(owned.value
          ? _unref(t)('memories', 'Are you sure you want to permanently remove album "{name}"?', { name: name.value })
          : _unref(t)('memories', 'Are you sure you want to leave the shared album "{name}"?', { name: name.value })), 1)
        ]),
        _: 1
      }, 512))
    : _createCommentVNode("", true)
}
}

})